/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogRelatedArticlesFragment} from '@amblique/contentful/app/contentful/fragments/blog-related-articles/base-blog-related-articles.fragment';
import {BlogFragment} from '@amblique/contentful/app/contentful/fragments/blog/blog.fragment';

export const FullBlogRelatedArticlesFragment = gql`
  ${BaseBlogRelatedArticlesFragment}
  ${BlogFragment}

  fragment FullBlogRelatedArticlesFragment on BlogRelatedArticles {
    ...BaseBlogRelatedArticlesFragment

    blogTagsCollection {
      items {
        __typename
        ... on Blog {
          ...BlogFragment
        }
      }
    }
    blogTagsCursorCollection {
      items {
        __typename
        ... on Blog {
          ...BlogFragment
        }
      }
    }
  }
`;
